import { Sidebar } from './Sidebar'
import { Topbar } from './Topbar'

export function AppShell({ children }: { children: React.ReactNode }) {
    return (
        <div className="bg-background text-foreground flex h-screen w-screen overflow-hidden">
            <Sidebar />
            <div className="flex min-w-0 flex-1 flex-col">
                <Topbar />
                <main className="flex-1 overflow-auto">
                    <div className="mx-auto w-full max-w-7xl px-6 py-6">{children}</div>
                </main>
            </div>
        </div>
    )
}
